<template>
	<div class="briefAnswer">
		<div class="questionnaire-title">{{content}}{{score ? `（${score}分）` : ""}}</div>
		<div class="questionnaire-briefAnswer">
			<textarea :maxlength="maxlength" :disabled="disabled" name="" id="" placeholder="请在此处输入..." v-model="componentValue[0]" @input="handleInput"></textarea>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			componentValue: []
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return []
			}
		},
		content: {
			type: String,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		maxlength: {
            type: String | Number,
            default: 100
		},
		score: {
			type: String,
			default: ""
		}
	},
	mounted() {
		this.componentValue = this.value
	},
	methods: {
		/**
            简答题输入事件
            @param { Event }  event 事件参数
            @return
        */
		handleInput(event) {
			this.$emit('change', [event.target.value])
		}
	},
	watch: {
		value(newValue) {
			this.componentValue = newValue
		}
	}
}
</script>

<style lang="scss" scoped>

.questionnaire-briefAnswer {
	textarea {
		width: 100%;
		padding: 0.16rem 0.32rem;
		min-height: 1.28rem;
		border-radius: 0.16rem;
		border: none;
		outline: none;
		background-color: #EFEFEF;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/components/briefAnswer.vue